import importHelper from './mfeImports'
let basePaths = null

const staticPaths = []

async function getValidEntryPoints (imports, tenantConfig) {
  const links = await importHelper.generateLinks(imports, tenantConfig)
  basePaths = [...staticPaths, ...links].map(l => {
    const path = l.route.replace('/', '')
    return `/__publicPath__/${path.length === 0 ? '?' : path}`
  })
  const validEntrypoints = basePaths.map(l => new RegExp(`^${l}.*`))

  if (links.length > 1) {
    basePaths = ['/__publicPath__/'].concat(basePaths)
    // eslint-disable-next-line prefer-regex-literals
    validEntrypoints.push(new RegExp('^/__publicPath__/?$'))
  }

  return validEntrypoints
}

async function initRoute (imports, tenantConfig) {
  const validEntrypoints = await getValidEntryPoints(imports, tenantConfig)
  const isValidPath = validEntrypoints.find(regex => regex.test(window.location.pathname))
  if (!isValidPath) {
    console.debug(`${window.location.pathname} is not a known path`)
    console.debug(`redirecting to ${basePaths[0]}`)
    history.replaceState(history.state, '', `${basePaths[0]}`)
  }
}

function getActiveContextApplications (applications) {
  const filtered = applications.filter(a => a.activeWhen.map(fn => fn()).some(b => !!b))
  console.log(filtered)
  return filtered
}

export default { initRoute, getActiveContextApplications }
